module.exports = __webpack_public_path__ + "img/9788954647144.f05ef154.jpg";